<template>
  <OpportunityListing />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import OpportunityListing from '@/components/opportunity/OpportunityListing.vue'
export default {
  name: 'OpportunityView',
  mounted() {
    let data = {
      firm: 1,
      category: 'App',
      name: 'RevenueShareFee'
    }
    this.resetPreferences()
    this.getPreferences(data)
  },
  components: {
    OpportunityListing
  },
  methods: {
    ...mapActions(locationStore, ['resetPreferences', 'getPreferences'])
  }
}
</script>
<style lang="scss" scoped></style>
